import { useStatsigClient } from "@statsig/react-bindings";

const useGate = (name: string) => {
  const { checkGate } = useStatsigClient();

  const value = checkGate(name);

  return value;
};

export default useGate;
